import { createApp } from 'vue';

import '@nedap/unrux/dist/unrux.css';
import '@nedap/unrux/scss/colors.scss';
import '../stylesheets/fonts/fonts.scss';

import { EnvironmentIndicator, Footer } from '@nedap/unrux';

import 'components/session/session.scss';

const app = createApp({
  components: {
    EnvironmentIndicator,
    'x-footer': Footer,
  }
});
app.mount('#app');
